module.exports = __webpack_public_path__ + "media/08_ASANBudapest-Custom08.797e3b38.mp3";